import {Redirect, Route, RouteProps} from "react-router-dom";
import {useContext} from "react";
import {UserType} from "../../../services/medicationmanagement/medsUser/MedsUserApi";
import { IdentityContext } from "../../auth/UserIdentity";

export const PharmacyRoute = (props:RouteProps)=>{
    let ctx = useContext(IdentityContext);
    if (ctx?.userInfo?.userType!==UserType.Pharmacist){
        return <Redirect to={"/"}/>
    }
    
    return (
        <Route {...props}>
            {props.children}
        </Route>
    );
}